import { render } from "./QuestVictory05.vue?vue&type=template&id=b4adcb46"
import script from "./QuestVictory05.vue?vue&type=script&lang=js"
export * from "./QuestVictory05.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questVictories/QuestVictory05.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4adcb46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4adcb46', __exports__)) {
    api.reload('b4adcb46', __exports__)
  }
  
  module.hot.accept("./QuestVictory05.vue?vue&type=template&id=b4adcb46", () => {
    api.rerender('b4adcb46', render)
  })

}


export default __exports__